import { jsx as _jsx } from "react/jsx-runtime";
import { DexfSettingsEnvironmentEnum } from '@inter-ikea-kompis/enums';
import { ProductService, SettingsService, TranslationsService } from '@inter-ikea-kompis/services';
import { useEffect, useState } from 'react';
import config from '../config';
import { guidaTheme } from '../themes';
import { getCurrentDexfSegment } from '../utils';
import LoadingIndicator from '../views/LoadingIndicator';
import { buildContext } from './buildContext';
import { useLocale } from './environment';
const translationEndpoints = [
    '/addon-app/translations/kompis/en-XZ.json',
    '/addon-app/translations/kompis/{language}-{country}.json',
    // Add application specific endpoints below
    '/addon-app/guida/pax-guide/translations/en-XZ.json',
    '/addon-app/guida/pax-guide/translations/{language}-{country}.json'
];
export const [useKompis, KompisContextProvider] = buildContext();
export const KompisProvider = ({ children }) => {
    const [productService, setProductService] = useState();
    const [dexfAppSettings, setDexfAppSettings] = useState();
    const [translations, setTranslations] = useState();
    const locale = useLocale();
    // Todo: change theme when kiosk
    const theme = guidaTheme;
    // Fetch application settings
    useEffect(() => {
        const fetchSettings = async () => {
            const settingsService = new SettingsService({
                dexfApiKey: config.dexfApiKey,
                dexfEnvironment: DexfSettingsEnvironmentEnum.production,
                dexfApplicationId: config.guidaDexfApplicationId,
                locale
            });
            const settings = await settingsService.getApplicationSettings(getCurrentDexfSegment());
            setDexfAppSettings(settings);
        };
        fetchSettings();
    }, [locale]);
    // Init translations
    useEffect(() => {
        const fetchTranslations = async () => {
            const translationsService = new TranslationsService({
                translationEndpoints,
                locale
            });
            const paxTranslations = await translationsService.getTranslations();
            setTranslations(paxTranslations);
        };
        fetchTranslations();
    }, [locale]);
    // Init product service
    useEffect(() => {
        const initProductService = async () => {
            if (dexfAppSettings) {
                const productService = new ProductService({
                    settings: dexfAppSettings,
                    locale,
                    dexfApiKey: config.dexfApiKey,
                    dexfApplicationId: config.paxDexfApplicationId
                });
                setProductService(productService);
            }
        };
        initProductService();
    }, [dexfAppSettings, locale]);
    if (!dexfAppSettings || !translations || !productService) {
        return _jsx(LoadingIndicator, {});
    }
    return (_jsx(KompisContextProvider, { value: {
            productService,
            dexfAppSettings,
            theme,
            translations
        }, children: children }));
};
//# sourceMappingURL=kompis.js.map